export default {
  header: "Calendar",
  view: "calendar",
  weather: {},
  events: [],
  username: {},
  date: new Date()
};
